import { render, staticRenderFns } from "./aufgaben-zusaetzliche-infos.vue?vue&type=template&id=6bbeb3ec"
import script from "./aufgaben-zusaetzliche-infos.vue?vue&type=script&lang=js"
export * from "./aufgaben-zusaetzliche-infos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports